import { isValidServiceDisplay } from './Service';
const defaultServiceDisplay = {
  id: 'n.a',
  name: 'n.a',
  provider: 'n.a'
};
export const serviceDisplayApiToServiceDisplay = service => {
  if (!service) {
    return defaultServiceDisplay;
  }
  const serviceDisplayWithDefaults = {
    ...defaultServiceDisplay,
    ...service
  };
  if (isValidServiceDisplay(serviceDisplayWithDefaults)) {
    return serviceDisplayWithDefaults;
  }
  throw new Error('Invalid serviceDisplayApi', {
    cause: {
      service
    }
  });
};
//# sourceMappingURL=converters.js.map